(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-card-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-card-variant-picker')) {
    customElements.define(
      'collection-card-variant-picker',
      class CollectionCardVariantPicker extends HTMLElement {
        connectedCallback() {
          requestAnimationFrame(() => this.initialize());
        }

        disconnectedCallback() {
          this.priceRequest?.abort();
        }

        initialize() {
          if (this.dataset.initialized === 'true' || !this.isConnected) return;

          this.dataset.initialized = 'true';
          this.optionInputs = this.querySelectorAll('[data-collection-option]');
          this.variantData = this.querySelector('[data-collection-variant-data]');
          this.variants = this.variantData ? JSON.parse(this.variantData.textContent) : [];
          this.productCard = this.closest('product-card');
          this.productUrl = this.productCard?.querySelector('[ref="productCardLink"]')?.href;
          this.variantInputs = this.productCard?.querySelectorAll('product-form-component [ref="variantId"]') || [];
          this.submitButtons = this.productCard?.querySelectorAll('product-form-component [ref="addToCartButton"]') || [];

          if (this.variants.length === 0) return;

          this.optionInputs.forEach((input) => input.addEventListener('change', () => this.updateVariant()));
          this.updateVariant(false);
        }

        updateVariant(shouldUpdatePrice = true) {
          const selectedOptions = [...this.querySelectorAll('[data-collection-option]:checked')].map((input) => input.value);
          const variant = this.variants.find(
            (item) => item.options.length === selectedOptions.length && item.options.every((option, index) => option === selectedOptions[index])
          );

          if (!variant) {
            this.variantInputs.forEach((input) => {
              input.disabled = true;
            });
            this.submitButtons.forEach((button) => {
              button.disabled = true;
            });
            return;
          }

          this.variantInputs.forEach((input) => {
            input.value = variant.id;
            input.disabled = !variant.available;
          });
          this.submitButtons.forEach((button) => {
            button.disabled = !variant.available;
          });
          if (shouldUpdatePrice) this.updatePrice(variant.id);
        }

        updatePrice(variantId) {
          if (!this.productUrl || !this.productCard) return;

          this.priceRequest?.abort();
          this.priceRequest = new AbortController();

          const requestUrl = new URL(this.productUrl, window.location.origin);
          requestUrl.searchParams.set('variant', variantId);
          requestUrl.searchParams.set('section_id', 'section-rendering-product-card');

          fetch(requestUrl, { signal: this.priceRequest.signal })
            .then((response) => response.text())
            .then((responseText) => {
              const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
              const newPrice = responseDocument.querySelector('product-price [ref="priceContainer"]');

              if (!newPrice || !this.productCard?.isConnected) return;

              this.productCard.querySelectorAll('product-price [ref="priceContainer"]').forEach((priceContainer) => {
                priceContainer.replaceWith(newPrice.cloneNode(true));
              });
            })
            .catch((error) => {
              if (error?.name !== 'AbortError') console.warn('[collection-card-variant-picker] Price update failed:', error);
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-option-carousel')) {
    customElements.define(
      'variant-option-carousel',
      class VariantOptionCarousel extends HTMLElement {
        connectedCallback() {
          this.scrollContainer = this.querySelector('[data-variant-carousel-scroll]');
          this.previousButton = this.querySelector('[data-variant-carousel-previous]');
          this.nextButton = this.querySelector('[data-variant-carousel-next]');

          if (!this.scrollContainer || !this.previousButton || !this.nextButton) return;

          this.previousButton.addEventListener('click', () => this.scrollBy(-1));
          this.nextButton.addEventListener('click', () => this.scrollBy(1));
          this.scrollContainer.addEventListener('scroll', () => this.updateButtons(), { passive: true });
          this.resizeObserver = new ResizeObserver(() => this.updateButtons());
          this.resizeObserver.observe(this.scrollContainer);
          this.updateButtons();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        scrollBy(direction) {
          this.scrollContainer.scrollBy({
            left: direction * Math.max(this.scrollContainer.clientWidth * 0.75, 160),
            behavior: 'smooth',
          });
        }

        updateButtons() {
          const maxScroll = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
          this.previousButton.disabled = this.scrollContainer.scrollLeft <= 1;
          this.nextButton.disabled = this.scrollContainer.scrollLeft >= maxScroll - 1;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
